import { put, SagaIterator, select, takeEvery } from './core/sagaEffects';
import { FetchRequest, MarkAsRead } from 'acscp/actions';
import { MarkAsReadRequest } from 'acscp/api/requests';
import { AppState, BookingReadDetails } from 'acscp/store';

export function readDetailsSelector(state: AppState, bookingId: string): BookingReadDetails {
    return state.bookingsReadDetails[bookingId];
}

export function* markAsReadSaga(): SagaIterator {
    yield takeEvery(MarkAsRead, markBookingReadOnServer);
}

export function* markBookingReadOnServer(action: MarkAsRead): SagaIterator {
    if (!action.isUserLoggedIn) {
        return;
    }

    const readDetails = (yield select(readDetailsSelector, action.bookingId)) as unknown as BookingReadDetails;

    // Don't call the server if we "read" this specific booking version already.
    // If we were asked to mark an unknown booking version as read,
    // then call the server anyway - it won't affect functionality, but it would be useful to obtain this data.
    if (readDetails.read && readDetails.contentIdentifier === action.contentIdentifier) {
        return;
    }

    const request = new MarkAsReadRequest(action.bookingId, action.contentIdentifier);
    yield put(new FetchRequest(request));
}
